export default "__VITE_ASSET__KEjONJWV__"